import { useMemo } from "react";
import SVGBulletList from "../../../../components/svg/SVGBulletList";
import SVGLineChart from "../../../../components/svg/SVGLineChart";
import {
  generateDummyEvents,
  getDOWStats,
  getHODStats,
  get14DayTrend,
  buildDOWBullets,
  buildHODBullets
} from "./DummyData";

export default function BulletCharts() {
  const events = useMemo(() => generateDummyEvents(), []);
  const dowStats = useMemo(() => getDOWStats(events), [events]);
  const hodStats = useMemo(() => getHODStats(events), [events]);
  const trendData = useMemo(() => get14DayTrend(events), [events]);

  const dowBullets = useMemo(() => buildDOWBullets(dowStats), [dowStats]);
  const hodBullets = useMemo(() => buildHODBullets(hodStats), [hodStats]);
  
  
  const dowData = dowBullets.slice(1, 6);

  // HOD → 9–17
  const hodData = hodBullets.slice(9, 17);
  
  
  const thisContainer = {
    marginTop: "16px",
    padding: "12px",
    borderRadius: "10px",
    background: "rgba(255,255,255,0.02)",
    border: "1px solid rgba(255,255,255,0.05)",
	flexDirection:'column',
	width:'250px'
  };
  
  
  const chartRow ={
	display:'flex',
	width:'100%',
	alignItems:'center'
  };
  
  const chartLabel = {
	display:'flex',
	width:'45px',
	fontSize:'10px',
	color:'#aaa',
	paddingLeft:'0px'
  };
  
  const chartContainer = {
	display:'flex',
	flexGrow:1
  };

  if (!events.length) return <div>Loading...</div>;

  return (
    <div style={thisContainer}>
		<div style={chartRow}>
			<div style={chartLabel}>
				DoW
			</div>
			<div style={chartContainer}>
				<SVGBulletList data={dowData} />
			</div>
		</div>
		<div style={chartRow}>
			<div style={chartLabel}>
				Hour
			</div>
			<div style={chartContainer}>
				<SVGBulletList data={hodData} />
			</div>
		</div>
		<div style={chartRow}>
			<div style={chartLabel}>
				<div style={{color:'red'}}>Bk</div>/<div style={{color:'orange'}}>Util</div>
			</div>
			<div style={chartContainer}>
				<SVGLineChart data={trendData} />
			</div>
		</div>
	
	
	

    </div>
  );
}